import React from 'react'
import { Container } from 'react-bootstrap'


function AboutUsSection() {
  return (
    <div>      
        <Container className='about-us-section' style={{ marginTop: '3rem', color: "#F5F5F5" }}>
            <h2>Our Mission: Empowering Business Success Through Expertise and Innovation</h2>
            <p>
                With over 6 years of industry experience and deep knowledge in operational consulting, JJS Consultancy brings you tailored solutions to help businesses thrive. JJS exists to service and assist in all business needs.
            </p>
        </Container>

        {/* Why Choose Us Section */}
        <Container className='why-choose-us-section' style={{ marginTop: '3rem', color: "#F5F5F5 " }}>
            <h2>Why Choose Us</h2>
            <ul>
                <li><strong>Proven Results:</strong> Proven success in enhancing financial and operational efficiency for clients.</li>
                <li><strong>Vast Network:</strong> We collaborate with an extensive network of consultants and businesses to provide the best advice.</li>
                <li><strong>Multi-Sector Expertise:</strong> Expertise in H&S, Customs, Transport, Logistics, Demand Planning, Accounting, and more.</li>
            </ul>
        </Container>
    </div>
  )
}

export default AboutUsSection